import { Dispatch } from 'react';
import { PricingApi } from '../../../api/api.apiclient';
import { OneWayFeeItemPriceRequest } from '../../../api/pricing/pricing.types';
import {
  EDIT_ONE_WAY_FEE_ITEM_PRICE,
  EditOneWayFeesItemPriceAction,
  GET_ONE_WAY_FEE_ITEM_PRICE
} from '../types/onewayfeesitemprice.types';

export const getOneWayFeeItemPrice = () => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.OneWayFees.getOneWayFeesItemPrice();
  dispatch({
    type: GET_ONE_WAY_FEE_ITEM_PRICE,
    payload: {
      itemPrice: response.data
    }
  });
  return Promise.resolve();
};

export const editOneWayFeesItemPrice = (oneWayFeesItemPriceRequest: OneWayFeeItemPriceRequest) => async (dispatch: Dispatch<EditOneWayFeesItemPriceAction>) => {
  const response = await PricingApi.OneWayFees.editOneWayFeesItemPrice(oneWayFeesItemPriceRequest);

  dispatch({
    type: EDIT_ONE_WAY_FEE_ITEM_PRICE,
    payload: {
      itemPrice: response.data
    }
  });
};
